import { displayModes } from 'services/enums/displayModes';
import Columns from './columns';

// CARE: ALWAYS INCREMENT THE VERSION IF THE SETTINGS FOR A COLUMN CHANGE!
// Config explanation
// optional: determines if the hidden status can be changed by the user
// hidden: determines if the field is shown or hidden
// conditional: indicates that the hidden status can be overriden using the conditions dictionary of the useTableConfig hook
const Config = {
  [displayModes.admin]: {
    version: 3,
    columns: {
      // This column is also used as a draggable handler and thus should never be optional or removed!!
      templateNumber: {
        columnName: Columns.templateNumber.name,
        optional: false,
        hidden: false,
        conditional: false,
        order: 1,
      },
      templateId: {
        columnName: Columns.templateId.name,
        optional: true,
        hidden: false,
        conditional: false,
        order: 2,
      },
      templateName: {
        columnName: Columns.templateName.name,
        optional: true,
        hidden: false,
        conditional: false,
        order: 3,
      },
      templateTemplateStops: {
        columnName: Columns.templateTemplateStops.name,
        optional: false,
        hidden: false,
        conditional: false,
        order: 4,
      },
      shipper: {
        columnName: Columns.shipper.name,
        optional: false,
        hidden: false,
        conditional: false,
        order: 5,
      },
      carrier: {
        columnName: Columns.carrier.name,
        optional: true,
        hidden: true,
        conditional: false,
        order: 6,
      },
      microHub: {
        columnName: Columns.microHub.name,
        optional: true,
        hidden: true,
        conditional: false,
        order: 7,
      },
      duration: {
        columnName: Columns.duration.name,
        optional: true,
        hidden: false,
        conditional: false,
        order: 8,
      },
      lengthKm: {
        columnName: Columns.lengthKm.name,
        optional: true,
        hidden: false,
        conditional: false,
        order: 9,
      },
      templateMetaData: {
        columnName: Columns.templateMetaData.name,
        optional: true,
        hidden: false,
        conditional: false,
        order: 10,
      }
    },
  },
  [displayModes.carrier]: {
    version: 1,
    columns: {},
  },
  [displayModes.shipper]: {
    version: 1,
    columns: {},
  },
};

export default Config;
